import { gql } from '@apollo/client';

export const COMPLETE_CLINICAL_USER_PROFILE = gql`
  mutation CompleteClinicalUserInvitation($data: CompleteInvitationInput!) {
    completeClinicalUserInvitation(data: $data) {
      token
      role
    }
  }
`;
